
import { ValidationProvider } from 'vee-validate';
export default {
  name: 'PhoneNumberInputWithValidation',
  components: {
    ValidationProvider,
  },
  props: {
    items: {
      type: [Object, Array],
      default: () => [],
    },
    mode: {
      type: String,
      default: 'aggressive',
    },
  },
  data: () => ({
    innerValue: {
      prefix: '',
      number: '',
    },
    prefix: '',
    number: '',
    prefixCountryCode: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue: {
      handler(newVal) {
        if (newVal.prefix === '') {
          this.prefixCountryCode = '';
        }
        this.$emit('input', newVal);
      },
      deep: true,
    },
  },
  methods: {
    onBlurPrefix() {
      this.$refs.autocompleteRef.setSearch('');
    },
    setSelectedPrefix(item) {
      if (!item || !item.phoneCode) {
        this.innerValue.prefix = '';
        return;
      }
      this.prefix = item.phoneCode;
      this.prefixCountryCode = item.alpha2code;
      this.innerValue.prefix = item.phoneCode;
    },
    svgIconHref(alpha2code) {
      return `https://purecatamphetamine.github.io/country-flag-icons/3x2/${alpha2code}.svg`;
    },
    customFilter(item, queryText) {
      if (!queryText) {
        return true;
      }
      const textToSearch = queryText.toLowerCase();
      return (
        item.name.toLowerCase().startsWith(textToSearch) ||
        item.phoneCode.includes(textToSearch)
      );
    },
  },
};
